module.exports = __webpack_public_path__ + "static/fonts/OpenSans-LightItalic.04efde4.woff";


//////////////////
// WEBPACK FOOTER
// ./static/font/OpenSans-LightItalic.woff
// module id = BfIo
// module chunks = 1